import React from 'react';
import { Route, Redirect } from 'react-router-dom';

// Hooks
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

type Props = {
  path: string;
  exact?: boolean;
  children: React.ReactNode;
  accessDeniedRedirectPath?: string;
};

function ManagerRoute({ children, accessDeniedRedirectPath = '/', ...rest }: Props) {
  const { isManager } = useCurrentUser();
  return (
    <Route
      {...rest}
      render={({ location }) =>
        isManager ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: accessDeniedRedirectPath,
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default ManagerRoute;
